import { Component, input } from '@angular/core'
import { Retention } from '../retention-article.model'
import { CourtDocumentsComponent } from '../../../../shared/components/court-documents/court-documents'

@Component({
    selector: 'app-retention-article',
    templateUrl: './retention-article.component.html',
    styleUrls: ['./retention-article.component.scss'],
    imports: [CourtDocumentsComponent]
})

export class RetentionArticleComponent {
  readonly article = input<Retention>()

}
